import { render, staticRenderFns } from "./fragile-cargo.vue?vue&type=template&id=2df6f031&"
import script from "./fragile-cargo.vue?vue&type=script&lang=js&"
export * from "./fragile-cargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports